import { joinParts } from '../utils'

export const typeticket = {
  data: (id: number) => joinParts('typetickets', String(id)),
  bulk: (ids: string[]) => `/typetickets?ids=${ids.join(',')}`,
}
